// Note: this file is temporary and will be removed on A/B test conclusion

/** Matches LESA_ESCALATION_TREATMENT_VARIATION in svc-support. */
export const LESA_ATI_REMOVAL_VARIATION = 'treatment'

export const LESA_ATI_REMOVAL_HUMAN_REQUESTED_EVENT = {
  key: 'lesa_ati_removal_human_requested',
  optimizelyEventId: '5355980819529728',
} as const

export const LESA_ATI_REMOVAL_CONTINUED_CHAT_EVENT = {
  key: 'lesa_ati_removal_continued_chat',
  optimizelyEventId: '5513882523926528',
} as const

export const LESA_ATI_REMOVAL_SUPPORT_NUMBER_CLICK_EVENT = {
  key: 'lesa_ati_removal_support_number_click',
  optimizelyEventId: '5760447150817280',
} as const

/**
 * Pills that mean "a human is on offer", in either arm. Control shows requestAgent /
 * confirmRequestAgent; treatment shows the swapped or appended escalation pills, and the
 * callback pill for high tier in AU/NZ.
 */
const ESCALATION_OFFER_ACTION_KEYS = new Set<string>([
  'requestAgent',
  'confirmRequestAgent',
  'requestSupportEscalation',
  'supportEscalationFollowUp',
  'requestAgentCallback',
])

export function offersEscalation(meta?: App.ChatMessageMeta): boolean {
  return !!meta?.content?.some((content) => {
    const key = content.action?.key
    return !!key && ESCALATION_OFFER_ACTION_KEYS.has(key)
  })
}

// The "No thank you, I want to keep speaking to you!" pill.
export function isContinueChatAction(category?: string): boolean {
  return category === 'chatLesa'
}

export function isEscalationActionKey(actionKey?: string): boolean {
  return !!actionKey && ESCALATION_OFFER_ACTION_KEYS.has(actionKey)
}
